(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) :
  factory();
})((function () { 'use strict';

  /*
   * Handles altering parent section of an Announcement Section component.
   */

  (function(){

    let announ_sects = document.querySelectorAll('.announcement-section');
    if (!announ_sects) return;

    for (let bar of announ_sects) {
      let parent_section = bar.closest('section'),
          child_links = bar.querySelectorAll('a');
      parent_section.className += ' as_parent';
      // This class is used to prevent the hover state color change for bars with buttons in them
      if ( child_links.length ) {
        parent_section.className += ' as_parent__has-btn';
      }
      // TODO: wrap a link around the section so some bars can have no button
    }

  })();

}));
